import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { etapasService } from '../services/etapas.service'
import type { EtapaFilters } from '../types'
import { cacheEtapas, getCachedEtapas } from '../../../lib/offlineDb'

export const ETAPAS_KEY = 'etapas'

export function useEtapas(filters: EtapaFilters = {}) {
  return useQuery({
    queryKey: [ETAPAS_KEY, filters],
    queryFn: async () => {
      const data = await etapasService.list(filters)
      if (filters.idcampeonato) {
        await cacheEtapas(filters.idcampeonato, data.data as unknown[])
      }
      return data
    },
  })
}

export function useCachedEtapas(idcampeonato: number) {
  return useQuery({
    queryKey: [ETAPAS_KEY, 'cached', idcampeonato],
    queryFn: async () => {
      const cached = await getCachedEtapas(idcampeonato)
      return cached as unknown[]
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: idcampeonato != null,
  })
}

export function useCreateEtapa() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: etapasService.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [ETAPAS_KEY] }),
  })
}

export function useUpdateEtapa() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => etapasService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ETAPAS_KEY] }),
  })
}

export function useDeleteEtapa() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => etapasService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ETAPAS_KEY] }),
  })
}
